













import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ListDaibunrui',
  components: {
    CtrlSearchCommonComponents,
  },

  props: {
    mukoUmuFlg: {
      type: Number,
    },
  },

  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'daibunruiCd',
        width: 55,
      },
      {
        text: '名称',
        sortable: true,
        value: 'daibunruiMei',
        width: 204,
      },
    ],
    formatColName: 'daibunruiCd',
  }),
});
